import { LAUNCH_DICE as SOCKET_LAUNCH_DICE} from '../../events/DashboardToServer'

export const DICE_LAUNCHED = 'DICE_LAUNCHED'
export const LAUNCH_DICE = 'LAUNCH_DICE'



export const dice = (state = [], action) => {
    switch (action.type) {
        case DICE_LAUNCHED:
            var ss = {
                ...state,
            }
            ss.launched = true
            return ss   
            
        default:
            return state
    }
}

export const launchDice = (socket) => {
    socket.emit(SOCKET_LAUNCH_DICE)
    return { type: LAUNCH_DICE}
}

export const diceLaunched = () => {
    return { type: DICE_LAUNCHED}
}



// WEBPACK FOOTER //
// ./src/reducers/dice/index.js